var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"elevation-10",attrs:{"outlined":"","align-self":"center","width":"420","max-width":"100%"}},[_c('v-card-title',{staticClass:"Auth__card justify-center display-1 font-weight-black"},[_vm._t("title")],2),_c('v-card-text',[_vm._t("form")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }